module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0039.jpg?v=7b916408";